<div *transloco="let t">
  @switch (template) { @case ("hero-1") {
  <div
    class="surface-section bg-no-repeat justify-content-center md:justify-content-end flex align-items-center text-center md:text-right"
    [ngStyle]="data.style">
    <div class="px-4 mx-4 lg:px-8 lg:mx-6 lg:py-8" style="padding-bottom: 20rem">
      <div class="text-6xl text-white font-bold">{{ data.title.firstLine }}</div>
      <div
        class="text-6xl text-primary font-bold mb-1"
        style="mix-blend-mode: hard-light"
        [innerHTML]="data.title.secondLine"></div>

      <p class="my-0 line-height-3 mx-auto text-white text-2xl" [innerHTML]="data.subtitle1"></p>
      <p class="mt-0 mb-4 line-height-3 mx-auto text-white">
        {{ data.subtitle2 }}
      </p>

      <p-button type="button" (click)="functionsMap[data.buttonFunction]()" *ngIf="data.button">
        {{ t(data.button) }}
      </p-button>
      @if(platform === 'web') {
      <p class="mt-4 mb-2 line-height-3 text-white text-xs" [innerHTML]="data.description"></p>
      <div class="flex md:justify-content-end align-items-center justify-content-center">
        @for(icon of data.icons; track i; let i=$index){
        <a [href]="'https://' + icon.url" target="_blank" class="text-white ml-3">
          <i [class]="'pi ' + icon.icon + ' text-xl'"></i>
        </a>
        }
      </div>
      }
    </div>
  </div>
  } @case ("hero-2") {
  <section class="surface-section py-8 px-2 md:px-6 lg:px-8 overflow-hidden relative">
    <div class="flex flex-wrap z-1 justify-content-center px-2">
      <article
        class="z-1 mt-8 xl:mt-0 xl:mb-0 xl:w-6 flex flex-column flex-order-1 xl:flex-order-0 align-items-start">
        <h2 class="font-bold text-3xl sm:text-3xl mt-0 mb-3">
          <span [innerHTML]="data.title.firstLine"></span>
          <br *ngIf="data.title.secondLine" />
          <span *ngIf="data.title.secondLine">{{ data.title.secondLine }}</span>
        </h2>
        <span
          *ngIf="data.subtitle"
          class="font-semibold text-md mb-2 text-primary"
          [innerHTML]="data.subtitle"></span>
        <p
          *ngIf="data.description"
          class="max-w-50rem py-0 line-height-3"
          style="max-width: 90%"
          [innerHTML]="data.description"></p>
        <p-button
          *ngIf="data.button"
          pButton
          pRipple
          type="button"
          icon="pi pi-arrow-right"
          iconPos="right"
          class="z-2 mt-2"
          [label]="t(data.button)"
          (click)="functionsMap[data.buttonFunction]()"></p-button>
      </article>

      <div class="w-full xl:w-6 relative flex justify-content-center align-items-center z-1">
        <img
          [src]="'assets/images/' + data.bg"
          [alt]="data.title.firstLine"
          style="border-radius: 0 25% 0; width: 100%" />
      </div>
    </div>
    <img
      src="assets/images/bg_chi_siamo_section.jpg"
      class="absolute top-0 z-0 right-0"
      style="translate: 30% -10%"
      alt="background" />
  </section>

  } @case ("hero-3") {

  <section class="py-8 md:px-6 lg:px-8 overflow-hidden relative" style="background-color: #efefe8">
    <div class="flex justify-content-around xl:flex-nowrap flex-wrap">
      <img
        class="w-full md:w-auto"
        [src]="'assets/images/' + data.bg"
        [alt]="data.title.firstLine" />
      <div class="flex flex-column justify-content-center p-3 w-80" style="max-width: 800px">
        <h2 class="text-4xl my-2">{{ data.title.firstLine }}</h2>
        <p class="line-height-3 mt-0" [innerHTML]="data.description"></p>
        <div class="mt-3">
          <!-- <app-carousel></app-carousel> -->
        </div>
      </div>
    </div>
  </section>

  } @case ("hero-4") {
  <section class="surface-section py-8 px-2 md:px-6 lg:px-8 overflow-hidden relative">
    <div class="flex flex-wrap z-1 justify-content-center px-2">
      <div
        class="xl:w-6 relative flex justify-content-center align-items-center z-1 order-0 xl:order-1">
        <img
          [src]="'assets/images/' + data.bg"
          [alt]="data.title.firstLine"
          style="border-radius: 25% 0 25% 0; width: 100%" />
      </div>
      <article
        class="z-1 mt-8 xl:mt-0 xl:mb-0 xl:w-6 flex flex-column flex-order-1 xl:flex-order-0 justify-content-center align-items-center xl:align-items-start order-1 xl:order-0 pl-0 lg:pl-8">
        <h2 class="font-bold text-3xl sm:text-3xl mt-0 mb-3">
          {{ data.title.firstLine }}

          @if(data.title.secondLine){
          <br />
          {{ data.title.secondLine }}
          }
        </h2>
        @if(data.subtitle){
        <span class="font-semibold text-md mb-2 text-primary">{{ data.subtitle }}</span>
        } @if(data.description){
        <p
          class="max-w-50rem py-0 line-height-3"
          style="max-width: 90%"
          [innerHTML]="data.description">
          {{ data.description }}
        </p>
        } @if(data.button){

        <p-button
          pButton
          pRipple
          type="button"
          icon="pi pi-arrow-right"
          iconPos="right"
          class="z-2 mt-2"
          [label]="t(data.button)"
          (click)="functionsMap[data.buttonFunction]()"></p-button>
        }
      </article>
      <img
        src="assets/images/bg_chi_siamo_section.jpg"
        class="absolute top-0 z-0 right-0"
        style="translate: -100% 10%"
        alt="background" />
    </div>
  </section>
  } @case ("hero-registration") {

  <div class="text-center my-6 relative">
    <div class="text-6xl mb-3 text-white flex justify-content-center flex-wrap">
      <div class="font-bold">{{ data.title }}</div>
    </div>
    <div
      class="text-xl text-white-alpha-70 line-height-2 text-center mx-auto mb-5"
      style="max-width: 500px">
      {{ data.description }}
    </div>

    <button
      pButton
      pRipple
      class="font-bold px-5 py-3"
      (click)="functionsMap[data.buttonFunction]()">
      {{ data.button }}
    </button>
  </div>
  } @default { Default case. } }
</div>
